import { render, staticRenderFns } from "./Measures.vue?vue&type=template&id=033b5db2&scoped=true&"
import script from "./Measures.vue?vue&type=script&lang=js&"
export * from "./Measures.vue?vue&type=script&lang=js&"
import style0 from "./Measures.vue?vue&type=style&index=0&id=033b5db2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b5db2",
  null
  
)

export default component.exports